// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageCropModal_root__2HvA9"};